import { AnyAction } from 'redux';

import { Events, getEvents } from '@ttstr/api';
import { getEventsReceived } from '@ttstr/reducers/events';

import { ThunkActionCreator } from '.';

export const EVENTS_REQUESTED = 'EVENTS.EVENTS_REQUESTED';
export const EVENTS_ALREADY_RECEIVED = 'EVENTS.EVENTS_ALREADY_RECEIVED';
export const EVENTS_RECEIVED = 'EVENTS.EVENTS_RECEIVED';
export const EVENTS_FAILED = 'EVENTS.EVENTS_FAILED';

export interface EventsReceivedAction extends AnyAction {
  payload: {
    events: Events;
  };
}

let requestEventsAbortController: AbortController;
export const requestEvents: ThunkActionCreator = () => async (dispatch, getState) => {
  if (requestEventsAbortController) requestEventsAbortController.abort();

  requestEventsAbortController = new AbortController();
  dispatch({
    type: EVENTS_REQUESTED,
  });

  try {
    // TODO This "cache" needs to be invalidated eventually
    if (getEventsReceived(getState())) {
      dispatch({
        type: EVENTS_ALREADY_RECEIVED,
      });
      return;
    }

    const events = await getEvents({ signal: requestEventsAbortController.signal });
    dispatch<EventsReceivedAction>({
      type: EVENTS_RECEIVED,
      payload: {
        events,
      },
    });
  } catch (error) {
    dispatch({
      type: EVENTS_FAILED,
      payload: {
        error,
      },
    });
  }
};
